import { Three2D } from "redhotmagma-visualization/Three/Three2D";

export class CustomThree2D extends Three2D {
  setupDefaultControls(...params) {
    super.setupDefaultControls(...params);
    super.toggleCameraLock(true);
  }
}
